import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Tile} from "../tile/Tile";
import styles from './Board.module.css'
import {
    BoardCellContents,
    BoardTileLocation,
    playTile,
    selectBoardState, selectChosenTileLocation,
    TileLocation,
} from "../game/gameSlice";
import {useDrop} from "react-dnd";
import React from "react";


type EmptySquareProps = {
    x: number,
    y: number,
    highlighted: boolean,
}

function EmptySquare({x, y, highlighted}: EmptySquareProps) {
    const dispatch = useAppDispatch();
    const chosenTileLocation = useAppSelector(selectChosenTileLocation);
    const positionOnBoard = {
        boardCol: x,
        boardRow: y
    };
    const [{isOver}, drop] = useDrop(
       () => ({
            accept: 'PLACE_TILE',
            drop: (item) => {
                const sourceLocation = item as TileLocation;
                dispatch(playTile({
                    source: sourceLocation,
                    ...positionOnBoard
                }))
            },
           collect: (monitor => ({
               isOver: !!monitor.isOver(),
           }))
       }),
    [x, y]
    )
    const classNames = [
        styles.dropTarget
    ]
    if (highlighted) {
        classNames.push(styles.highlighted);
        if (isOver) {
            classNames.push(styles.over);
        }
    }
    return <div
        ref={drop}
        className={classNames.join(' ')}
        onPointerUp={() => {
            if (chosenTileLocation) {
                dispatch(playTile({
                    source: chosenTileLocation,
                    boardCol: x,
                    boardRow: y,
                }))
            }
        }}
    >
    </div>
}


type BoardRowProps = {
    index: number,
    contents: BoardCellContents[],
}


function Row(row: BoardRowProps) {
    const boardRow = row.index;
    const elements = row.contents.map((cell, i) => {
        const boardCol = i;
        if (cell.tile) {
            const location: BoardTileLocation = {
                kind: "board",
                boardCol,
                boardRow,
            };
            return (
                <Tile
                    isFocussed={cell.isFocussed}
                    isChosen={cell.isChosen}
                    tile={cell.tile}
                    location={location}
                    rotationTypes={cell.rotationTypes}
                />
            )
        } else {
            return <EmptySquare x={boardCol} y={boardRow} highlighted={!!cell.highlighted} />
        }
    });
    return (
        <div className={styles.row}>
            {elements.map((element, key) =>
                <div key={key} className={styles.cell}>
                    { element }
                </div>
            )}
        </div>
    )
}

export function Board() {
    const boardState = useAppSelector(selectBoardState);

    return (
        <div className={styles.board}>
            {
                boardState.rows.map((row: BoardCellContents[], rowNumber) =>
                    <Row
                        key={rowNumber}
                        index={rowNumber}
                        contents={row}
                    />
                )
            }
        </div>
    )
}